export enum ProfilePageActions {
  UPDATE_PROFILE_PIC              = 'UPDATE_PROFILE_PIC',
  PROFILE_UPDATED                 = 'PROFILE_UPDATED',
  COVER_PIC_UPDATE                = 'COVER_PIC_UPDATE',
  SHOW_COMMON_PROFILE_EDIT_DIALOG = 'SHOW_COMMON_PROFILE_EDIT_DIALOG',
  ASSIST_PROFILE                  = 'ASSIST_PROFILE'
}
